import ArtistEdition from './ArtistEdition';

export default ArtistEdition;
